import { Link } from "react-router-dom";
import type { CatalogProduct } from "@/lib/catalog";
import { BuyLink } from "@/components/BuyLink";
import { Button } from "@/components/ui/button";
import { RatingStars } from "@/components/RatingStars";
import { SmartImage } from "@/components/SmartImage";
import { YberaPrice } from "@/components/YberaPrice";

type ProductCardProps = {
  product: CatalogProduct;
};

export function ProductCard({ product }: ProductCardProps) {
  return (
    <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-card transition-shadow hover:shadow-card-hover">
      <Link to={product.path} className="block aspect-square overflow-hidden bg-muted">
        {product.image ? (
          <SmartImage
            src={product.image}
            alt={product.name}
            width={400}
            height={400}
            className="h-full w-full object-cover"
            sizes="(max-width: 640px) 50vw, 33vw"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-muted-foreground">Sem imagem</div>
        )}
      </Link>
      <div className="flex flex-1 flex-col gap-3 p-5">
        <RatingStars />
        <h3 className="font-sans text-lg font-bold leading-snug tracking-tight text-neutral-900">
          <Link to={product.path} className="hover:text-neutral-900">
            {product.name}
          </Link>
        </h3>
        <div className="mt-auto">
          <YberaPrice product={product} />
        </div>
        <div className="flex flex-col gap-2">
          <BuyLink product={product} size="default">
            Comprar na Ybera
          </BuyLink>
          <Button asChild variant="ghost" size="sm">
            <Link to={product.path}>Ver como usar</Link>
          </Button>
        </div>
      </div>
    </article>
  );
}
